export default "__VITE_ASSET__pGf2iYbR__"